module.exports = "https://static.energy5.com/_next/static/images/hvacBg-b1cc3e7986b33e89724410f1ae9dee42.webp";